'use client';

import React, { useEffect } from 'react';
import { useAtom } from 'jotai';
import { message } from 'antd';
import { isOnlineAtom } from '@/global/store/atoms';
import { useTranslations } from 'next-intl';

export const ConnectivityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOnline, setIsOnline] = useAtom(isOnlineAtom);
  const t = useTranslations();

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      message.success(t('common.back_online'));
    };

    const handleOffline = () => {
      setIsOnline(false);
      message.error(t('common.connection_lost'));
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Initial check
    if (!navigator.onLine && isOnline) {
      handleOffline();
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [isOnline, setIsOnline]);

  return <>{children}</>;
};
